/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



// ===================== ANIMATION : BOTTOM : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniProgressBarShareBottomInitial = {
    // ~~~~~~~~~~~~~~~~~~~~~ INITIAL STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: '0',
        width: '100%',
        position: 'absolute',
        bottom: pxToEm(1),
        zIndex: '2'
    },
    '& .progressbar.type-result': {
        marginBottom: '0',
        marginTop: pxToEm(12)
    },
    // remove progess bar and share icons immediately (so they can be animated later)
    '& .progressbar.type-result, .facebook, .twitter': {
        transform: 'translateY(300%)',
        opacity: '0'
    },
    '& .rewardsfeedback': {
        '& .icon, .text': { opacity: '0', transform: 'translateX(-300%)' }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thin]: {
        '& .resultelements': {
            fontSize: '85%',
            textAlign: 'center'
        }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniProgressBarShareBottomInitial };